module.exports = __webpack_public_path__ + "media/images/client-authority-brands-f0ab8e3b93e53b223cf792cc2535e08e.png";